import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TimeSvg = () => {
  return (
    <OverlayTrigger
      overlay={
        <Tooltip id={`tooltip-reset`} key={"reset"}>
          <strong>Reset Filter</strong>
        </Tooltip>
      }
      placement={"top"}
    >
      <div class="refresh-area">
        <span>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.666748 2.66666V6.66666H4.66675"
              stroke="#202223"
              stroke-opacity="0.5"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M2.34008 10C2.77234 11.2269 3.59164 12.2801 4.67452 13.0009C5.7574 13.7217 7.0452 14.0711 8.34389 13.9963C9.64258 13.9216 10.8818 13.4268 11.8748 12.5865C12.8679 11.7462 13.5609 10.606 13.8496 9.33758C14.1382 8.06917 14.0068 6.74131 13.4752 5.55407C12.9435 4.36684 12.0404 3.38454 10.902 2.75518C9.76351 2.12583 8.45135 1.88352 7.1632 2.06475C5.87505 2.24599 4.68069 2.84095 3.76008 3.76001L0.666748 6.66667"
              stroke="#202223"
              stroke-opacity="0.5"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </span>
      </div>
    </OverlayTrigger>
  );
};

export default TimeSvg;
